import { render, staticRenderFns } from "./Seccion1View.vue?vue&type=template&id=4d341efb&"
import script from "./Seccion1View.vue?vue&type=script&lang=ts&"
export * from "./Seccion1View.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports